export const INTERVALS = ['1m', '5m', '15m', '30m', '1h', '4h', '1d'] as const;
export type Interval = typeof INTERVALS[number];

const DAY_MS = 24 * 60 * 60 * 1000;

export function getDefaultInterval(from: Date, to: Date): Interval {
    const spanMs = to.getTime() - from.getTime();
    if (spanMs <= 0) return '1m';
    const spanDays = spanMs / DAY_MS;

    if (spanDays < 1) return '1m';
    if (spanDays < 3) return '5m';
    if (spanDays < 7) return '15m';
    if (spanDays < 14) return '30m';
    if (spanDays < 28) return '1h';
    if (spanDays < 180) return '4h';
    return '1d';
}
